











import { Component, Prop, Vue } from 'vue-property-decorator';
import { ButtonBlockDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
@Component({
  components: {CmsLink},
})
export default class ButtonBlock extends Vue {
  @Prop({required: true})
  public readonly model!: ButtonBlockDto;
}
